import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Card from '../../../../shared/components/Card';
import CardSimpleHeader from '../../../../shared/components/CardSimpleHeader';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import MessagesList from './MessagesList';
import HeaderSearchRefreshFilterOptions from '../../../../shared/components/HeaderSearchRefreshFilterOptions';
import CardBody from '../../../../shared/components/CardBody';
import AddMessage from './AddMessage';
import { bindActionCreators } from 'redux';
import * as messagesActions from '../shared/actions/messagesActions';
import { connect } from 'react-redux';
import Paginator from '../../../../shared/components/Paginator';
import { PsMessage } from '../../PsMessage';
import { PsCompany } from '../../../../shared/model/company/PsCompany';
import { ListTargetCompaniesTask } from './ws/ListTargetCompaniesTask';
import { ListTargetCompaniesRequest } from './ws/ListTargetCompaniesRequest';
import Alert from 'react-s-alert';

const INITIAL_STATE = { page: 1, search: '', filter: 0 };

class CardMessages extends React.Component {

    constructor(props) {
        super(props);
        this.onRefresh = this.onRefresh.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onPage = this.onPage.bind(this);
        this.onCollapsed = this.onCollapsed.bind(this);
        this.state = {
            ...INITIAL_STATE,
            collapsed: this.props.initCollapsed ? true : false,
            loading: false,
            targetCompanies: [],
        };
    }

    componentWillMount() {
        if ( !this.state.collapsed ) {
            this.getMessages();
            this.getTargetCompanies();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if ( prevState.search !== this.state.search
            || prevState.filter !== this.state.filter
            || prevState.page !== this.state.page
            || prevState.collapsed !== this.state.collapsed
        ) {
            if ( !this.state.collapsed ) {
                this.getMessages();
            }
        }
    }

    buildQueryIds() {
        const queryIds = {};
        if ( this.props.machineId ) queryIds.machine_id = this.props.machineId;
        if ( this.props.workerId ) queryIds.worker_id = this.props.workerId;
        if ( this.props.companyId ) queryIds.company_id = this.props.companyId;
        if ( this.props.constructionId ) queryIds.construction_id = this.props.constructionId;
        if ( this.props.documentId ) queryIds.document_id = this.props.documentId;
        return queryIds;
    }

    getMessages() {
        this.props.messagesActions.getMessages(this.state.page, this.state.search, this.state.filter, this.buildQueryIds());
    }

    onRefresh() {
        this.getMessages();
    }

    onSearch(search) {
        this.setState({ search: search, page: 1 });
    }

    onPage(page) {
        this.setState({ page });
    }

    onCollapsed(collapsed) {
        this.setState({ collapsed: collapsed });
        if ( this.props.collapsed ) {
            this.props.collapsed(collapsed);
        }
    }

    renderFilterName() {
        const states = _.keyBy(this.props.workersStates, 'id');
        if ( states && states[this.state.filter] ) {
            return states[this.state.filter].name;
        }
        return '';
    }

    renderHeaderOptions() {
        const filterOptions = [
            {
                title: I18nUtils.tr('TR_VER_TODAS'),
                active: 0 === this.state.filter,
                onClick: () => {
                    this.setState({ filter: 0 });
                },
            },
            {
                title: I18nUtils.tr('TR_VER_ABIERTAS'),
                active: 1 === this.state.filter,
                onClick: () => {
                    this.setState({ filter: 1 });
                },
            },
            {
                title: I18nUtils.tr('TR_VER_CERRADAS'),
                active: 2 === this.state.filter,
                onClick: () => {
                    this.setState({ filter: 2 });
                },
            },
        ];
        return (
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.onRefresh}
                enableFilter={true}
                enableRefresh={true}
                enableSearch={false}
                filterOptions={filterOptions}
                cardSearchFilterEnabled={false}
                collapsed={this.state.collapsed}
                onCollapsed={this.props.initCollapsed !== null ? this.onCollapsed : undefined}
            />
        );
    }

    renderAddMessage() {
        const { canAddMessage } = this.props;
        const { targetCompanies } = this.state;

        if ( canAddMessage ) {
            return <AddMessage
                addMessageSuccess={() => {
                    this.setState(INITIAL_STATE);
                    this.getMessages();
                }}
                queryIds={this.buildQueryIds()}
                targetCompanies={targetCompanies}
            />;
        }
        return null;
    }

    renderMessages() {
        if ( this.props.messagesError ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.messagesError}</h3>
                </section>
            );
        }
        return (
            <MessagesList
                data={PsMessage.fromAPIMessages(this.props.messages)}
                canResponseMessage={this.props.canResponseMessage}
            />
        );
    }

    render() {
        return (
            <Card colWidth={this.props.colWidth} loading={this.props.messagesLoading}>
                <CardSimpleHeader title={I18nUtils.tr('TR_MENSAJES')} options={this.renderHeaderOptions()}/>
                {this.renderAddMessage()}
                {!this.state.collapsed && <CardBody>
                    {this.renderMessages()}
                    <Paginator onPage={this.onPage} data={this.props.messagesPagination}/>
                </CardBody>}
            </Card>
        );
    }

    getTargetCompanies = () => {
        const {
            workerId,
            machineId,
            documentId,
        } = this.props;

        if ( !workerId && !machineId && !documentId ) {
            return;
        }

        const request = new ListTargetCompaniesRequest();
        request.setWorkerId(workerId);
        request.setMachineId(machineId);
        request.setDocumentId(documentId);

        new ListTargetCompaniesTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess(res => {
                const targetCompanies = PsCompany.fromAPICompanies(res.data);
                this.setState({ targetCompanies });
            })
            .onFail(error => Alert.error(error))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

}

const mapStateToProps = state => {
    let errorMessage = state.messages.messagesError;
    if ( !errorMessage && state.messages.messages.length === 0 && !state.messages.messagesLoading ) {
        errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
    }
    return ( {
        messages: state.messages.messages,
        messagesPagination: state.messages.messagesPagination,
        messagesLoading: state.messages.messagesLoading,
        messagesError: errorMessage,
    } );
};

const mapDispatchToProps = dispatch => ( {
    messagesActions: bindActionCreators(messagesActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(CardMessages);

CardMessages.propTypes = {
    colWidth: PropTypes.string,
    canAddMessage: PropTypes.bool,
    canResponseMessage: PropTypes.bool,

    companyId: PropTypes.any,
    documentId: PropTypes.any,
    machineId: PropTypes.any,
    constructionId: PropTypes.any,
    workerId: PropTypes.any,
    initCollapsed: PropTypes.bool,
    collapsed: PropTypes.func,
};

CardMessages.defaultProps = {
    canAddMessage: true,
    canResponseMessage: true,

    companyId: null,
    documentId: null,
    machineId: null,
    constructionId: null,
    workerId: null,
    initCollapsed: null,
    collapsed: (collapsed) => {},
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/card/CardMessages.js